import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Google Analytics 4 page tracking for Single Page Applications.
 * Automatically sends a page_view event on every route change.
 */
export default function GoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    const gtag = window.gtag as
      | ((
          command: string,
          targetId: string,
          config?: Record<string, unknown>
        ) => void)
      | undefined;

    if (typeof gtag === "function") {
      gtag("config", "G-QPCMFHPJWY", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
      });
    }
  }, [location]);

  return null;
}

// Extend Window interface so TypeScript knows about gtag
// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface Window {
  gtag?: (
    command: string,
    targetId: string,
    config?: Record<string, unknown>
  ) => void;
  dataLayer?: unknown[];
}